import React from 'react';

import styles from './troy.module.scss';
import emoji from '../../assets/img/allgemein/07_emoji-smile.png';

import { ChoiceForm, Translation, Grid } from '../../components/common';
import { connectTo } from '../../utils';
import { getQuestions, sendAnswers } from '../../actions/questions';
import { MESSAGE_TO_AGENCY, FEEDBACK, THANKS } from '../../constants/routes';
import Wayne from '../../assets/img/welcome/wayne_enterprises__earth-9925_.png';
import NamedAvatar from '../../components/common/NamedAvatar/index.troy';

const headerKey = 'CHECKOUT_TOP_HEADER';
const contentKey = 'CHECKOUT_TOP';
const optionsHeaderKey = 'CHECKOUT_BOTTOM_HEADER';

class MessageToClient extends React.Component {
  componentDidMount() {
    const { getQuestions, questions, language } = this.props;
    if (!questions && language) {
      getQuestions();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { getQuestions, language } = this.props;
    if (language !== prevProps.language) {
      getQuestions();
    }
  }

  onSubmit = (values) => {
    const {
      questions,
      sendAnswers,
      history,
      showMessageToAgency,
      showFeedback,
    } = this.props;
    sendAnswers({
      answers: questions
        ? questions.map(({ group, id }) => ({
            group,
            id,
            value: !!values[id],
          }))
        : null,
    });
    history.push(
      showMessageToAgency ? MESSAGE_TO_AGENCY : showFeedback ? FEEDBACK : THANKS
    );
  };

  render() {
    const { translations, questions } = this.props;
    return (
      <div className={styles['message-to-client__wrapper']}>
        <div className={styles['message-to-client__header-wrapper']}>
          <Grid
            container
            spacing={2}
            justify="space-between"
            className={styles['message-to-client__header']}
          >
            <Grid item xs className={styles['message-to-client__header-item']}>
              <NamedAvatar
                className={styles['message-to-client__header-avatar']}
                withoutDescription
              />
            </Grid>
            <Grid item xs className={styles['message-to-client__header-item']}>
              <img
                alt=""
                src={Wayne}
                className={styles['message-to-client__header-image']}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles['message-to-client__head']}>
          <img
            className={styles['message-to-client__head-emoji']}
            src={emoji}
            alt="emoji"
          />
          <h2 className={styles['message-to-client__head-header']}>
            <Translation>{headerKey}</Translation>
          </h2>
          <div className={styles['message-to-client__head-content']}>
            <Translation>{contentKey}</Translation>
          </div>
          <ChoiceForm
            onSubmit={this.onSubmit}
            {...{ questions, styles }}
            header={translations && translations[optionsHeaderKey]}
            button="ABSCHICKEN"
            pageName="message-to-client"
          />
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    translations: { translations, language },
    questions: { toClient },
    payment: {
      show: { feedback, messageToAgency },
    },
  }) => ({
    translations,
    language,
    questions: toClient,
    showFeedback: feedback,
    showMessageToAgency: messageToAgency,
  }),
  { getQuestions, sendAnswers },
  MessageToClient
);
